import { useEffect } from 'react';
import { prefetchRouteChunks } from '@/lib/prefetch-routes';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Warm Designer / MDM Devices / Templates after sign-in. All three routes are
 * protected, so logged-out visitors must not download their page graphs.
 * Subscribe to token presence so Firebase token rotation does not schedule another
 * warm-up. A later logout/sign-in transition can schedule prefetch again.
 * The gate lives in this hook so its auth transitions can be tested independently.
 */
export function usePrefetchAuthenticatedRoutes(): void {
  const isAuthed = useAuthStore((s) => Boolean(s.token));

  useEffect(() => {
    if (!isAuthed) return;
    prefetchRouteChunks();
  }, [isAuthed]);
}
